export {default} from './productCardV3';
